import { render, staticRenderFns } from "./ManageMaintenances.vue?vue&type=template&id=06796a93"
import script from "./ManageMaintenances.vue?vue&type=script&lang=ts"
export * from "./ManageMaintenances.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports